/**
 * Drop a hint — posts the form to the configured endpoint (Cloudflare Worker),
 * which emails the recipient via Resend. See cloudflare-worker/README.md.
 */
(function () {
  function getStrings(form) {
    try {
      return JSON.parse(form.getAttribute('data-strings') || '{}');
    } catch (e) {
      return {};
    }
  }

  function fieldValue(form, name) {
    var input = form.querySelector('[name="' + name + '"]');
    return input ? input.value.trim() : '';
  }

  function subscribeToNewsletter(email) {
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '\u2713');
    fd.append('contact[email]', email);
    fd.append('contact[accepts_marketing]', 'true');
    fetch('/contact', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    }).catch(function () {});
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-drop-hint-form]');
    if (!form) return;

    event.preventDefault();

    var strings = getStrings(form);
    var endpoint = form.getAttribute('data-endpoint');

    if (!endpoint) {
      window.alert(strings.config_error || 'The hint service is not configured.');
      return;
    }

    if (!form.reportValidity()) return;

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }

    var payload = {
      senderName: fieldValue(form, 'sender_name'),
      senderEmail: fieldValue(form, 'sender_email'),
      recipientName: fieldValue(form, 'recipient_name'),
      recipientEmail: fieldValue(form, 'recipient_email'),
      message: fieldValue(form, 'message'),
      productTitle: form.getAttribute('data-product-title') || '',
      productUrl: form.getAttribute('data-product-url') || '',
      website: fieldValue(form, 'website'),
    };

    var modalRoot = form.closest('modal-dialog');
    var successEl = modalRoot && modalRoot.querySelector('[data-drop-hint-success]');
    var formWrap = modalRoot && modalRoot.querySelector('[data-drop-hint-form-wrap]');

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { ok: res.ok && data.ok === true, error: data.error };
          });
      })
      .then(function (result) {
        if (result.ok) {
          var subscribe = form.querySelector('[data-drop-hint-subscribe]');
          if (subscribe && subscribe.checked && payload.senderEmail) {
            subscribeToNewsletter(payload.senderEmail);
          }
          if (formWrap) formWrap.hidden = true;
          if (successEl) successEl.hidden = false;
        } else {
          window.alert(result.error || strings.error || 'Something went wrong. Please try again.');
        }
      })
      .catch(function () {
        window.alert(strings.error || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
      });
  });
})();
